import React from "react";
import { TextReducer } from "../../components/Card";
import { UserApi } from "../../app/api/user.api";
import { useQuery } from "@tanstack/react-query";


export function LeftSidebar() 
{

 
  return (

    <div className="col-lg-4"> 
      <div className="row sticky-top">
        {/* ************************************* */}
        <div className="col-lg-12 mb-4">
          <Userbar />
        </div>
        {/* *********************************** */}
        <div className="col-lg-12 mb-4">
          <div className="border bg-white text-secondary rounded-3">
            <div className="d-flex align-items-center border-bottom px-3 py-2 lead text-dark">
              Note d'information
            </div>  
            <div className="d-flex align-items-center border-bottom px-3 py-4 small">
             Les délais de livraison ou d’installation sont communiqués lors de la validation de la commande. Ils peuvent varier selon la disponibilité des produits et les spécificités techniques.
            </div>            
            <div className="d-flex align-items-center p-3">
              <a href="/nouveau-commande" className="btn-sm btn btn-green py-2 px-3 d-flex justify-content-center align-items-center"> 
                <i className="bi bi-plus-circle me-2"></i>  Nouvelle commande 
              </a> 
            </div> 
          </div>
        </div>
        {/* *********************************** */}
        <div className="col-lg-12 mb-4">
          <div className="border bg-green text-secondary rounded-3 p-2">
            <div className="d-flex align-items-center px-3 py-2 lead text-light border-bottom">
              Pour plus d'informations, n'hésitez pas à nous contacter
            </div>            
            <div className="d-flex align-items-center p-3">
              <a href="/contact" className="btn-sm btn btn-outline-light py-2 px-3 d-flex justify-content-center align-items-center"> 
                Contact <i className="bi bi-chevron-right ms-2"></i>
              </a> 
            </div> 
          </div>
        </div>
        {/* ************************************* */}
      </div>
    </div>

  );
}




export function Userbar() 
{

  const user = UserApi(); 
    
  const fetchData = async () => { 
    const {data} = await user.findCurUser();
    return data.user; 
  }
  const { data } = useQuery({  queryKey: ["user"], queryFn: fetchData });


  return (

    <div className="border bg-white text-secondary rounded-top-3">
      <div className="d-flex align-items-center p-3">
        <div className="me-2">
          <div className="border bg-dark text-white rounded-circle d-flex align-items-center justify-content-center fw-bold small" style={{ width:40, height:40}}>
            { data?.fname ? data?.fname.charAt(0).toUpperCase() : ""}{ data?.lname ? data?.lname.charAt(0).toUpperCase() : ""}
          </div>
        </div>
        <div>
          <div className="fw-bold text-secondary small" title={ data?.fname + ' ' + data?.lname }> <TextReducer text={ data?.fname + ' ' + data?.lname} maxsize={24} /> </div>
          <div className="text-secondary small" title={ data?.email }> <TextReducer text={ data?.email } maxsize={24} /> </div>
        </div>
      </div>
    </div>

  );
}





export function Topbar({active}) 
{
 
  return (

    <nav className="navbar navbar-expand-sm">
      <div className="container-fluid">
        <button className="navbar-toggler small" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav2" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon small"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav2">
          <ul className="navbar-nav my-2 px-3 gap-3">
            <li>
              <a className={`btn btn-sm rounded-0 px-3 ${(active===1) ? 'btn-green' : 'btn-outline-green'}`} href="/commandes-en-cours"> En cours </a>
            </li>
            <li>
              <a className={`btn btn-sm rounded-0 px-3 ${(active===2) ? 'btn-green' : 'btn-outline-green'}`} href="/commandes-livrees"> Livrées </a>
            </li>
             <li>
              <a className={`btn btn-sm rounded-0 px-3 ${(active===3)  ? 'btn-green' : 'btn-outline-green'}`} href="/commandes-annulees"> Annulées </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

  );
}




export function formatDateTime(dateString) 
{
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} à ${hours}:${minutes}`;
}
